var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_178_963)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9723 14.991H13.889C11.9714 14.991 10.4167 16.593 10.4167 18.5688V19.2844C10.4167 19.6798 10.7275 20 11.1112 20H13.1945C15.1121 20 16.6667 18.398 16.6667 16.4222V15.7066C16.6667 15.3112 16.356 14.991 15.9723 14.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.77778 14.991H0.694444C0.310764 14.991 0 15.3112 0 15.7066V16.4222C0 18.398 1.55469 20 3.47222 20H5.55556C5.93924 20 6.25 19.6798 6.25 19.2844V18.5688C6.25 16.593 4.69531 14.991 2.77778 14.991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2779 7.11983C15.2588 3.16768 12.1338 -0.0197094 8.29873 -3.14441e-05C4.46366 0.0200938 1.36991 3.23968 1.389 7.19138C1.4068 10.8524 4.10341 13.9092 7.639 14.2755V19.2844C7.639 19.6798 7.94977 20 8.33345 20C8.71713 20 9.02789 19.6798 9.02789 19.2844V14.2755C12.5895 13.9065 15.2957 10.8081 15.2779 7.11983ZM5.84039 9.6243C5.6147 9.30453 5.68327 8.8573 5.9936 8.62475C6.30393 8.39219 6.73796 8.46285 6.96366 8.78262C6.99143 8.82197 7.01531 8.86446 7.03484 8.90873C7.1594 9.13101 7.38987 9.26741 7.639 9.26652H9.02789C9.41157 9.26652 9.72234 8.9463 9.72234 8.55095C9.72234 8.1556 9.41157 7.83539 9.02789 7.83539H7.639C6.4884 7.83539 5.55567 6.8743 5.55567 5.6887C5.55567 4.5031 6.4884 3.54201 7.639 3.54201V2.82644C7.639 2.4311 7.94977 2.11088 8.33345 2.11088C8.71713 2.11088 9.02789 2.4311 9.02789 2.82644V3.54201C9.77008 3.54424 10.4554 3.95301 10.8265 4.61535C11.0522 4.93512 10.9836 5.38235 10.6733 5.61491C10.363 5.84746 9.92893 5.7768 9.70324 5.45703C9.67546 5.41768 9.65159 5.37519 9.63206 5.33092C9.50749 5.10864 9.27702 4.97224 9.02789 4.97314H7.639C7.25532 4.97314 6.94456 5.29335 6.94456 5.6887C6.94456 6.08405 7.25532 6.40426 7.639 6.40426H9.02789C10.1785 6.40426 11.1112 7.36535 11.1112 8.55095C11.1112 9.73655 10.1785 10.6976 9.02789 10.6976V11.4132C9.02789 11.8086 8.71713 12.1288 8.33345 12.1288C7.94977 12.1288 7.639 11.8086 7.639 11.4132V10.6976C6.89682 10.6954 6.21149 10.2866 5.84039 9.6243Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_178_963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower);
export default __webpack_public_path__ + "static/media/flower.f9905cd15cf2da6cb47c03f859c17e59.svg";
export { ForwardRef as ReactComponent };